import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import { icon } from './ui';
import { portalEvent, portalHome } from './portalApi';
export default class HomeAnnouncements extends Component {
  data = {
    announcements: []
  };
  dismissed = [];
  oninit(vnode) {
    super.oninit(vnode);
    try {
      this.dismissed = JSON.parse(localStorage.getItem('nt-dismissed-announcements') || '[]');
    } catch {
      this.dismissed = [];
    }
    portalHome().then(data => {
      this.data = data;
      m.redraw();
    });
  }
  dismiss(id) {
    const key = String(id);
    if (!this.dismissed.includes(key)) this.dismissed.push(key);
    localStorage.setItem('nt-dismissed-announcements', JSON.stringify(this.dismissed));
    m.redraw();
  }
  track(url) {
    portalEvent({
      action: 'analytics',
      consent: localStorage.getItem('nt-analytics-consent') === 'yes',
      visitor_id: localStorage.getItem('nt-visitor-id') || 'anonymous',
      event_type: 'social_exit',
      path: location.pathname,
      target_url: url,
      browser: navigator.userAgent.slice(0, 80),
      device: matchMedia('(max-width:767px)').matches ? 'mobile' : 'desktop'
    }).catch(() => null);
  }
  view() {
    const announcements = (this.data.announcements || []).filter(item => !this.dismissed.includes(String(item.id)));
    if (!announcements.length) return null;
    return m("section", {
      className: "container NtHomeAnnouncements",
      "aria-label": "Og\u0142oszenia globalne"
    }, announcements.map(item => m("article", {
      className: `NtAnnouncement is-${item.style || 'gold'}`
    }, m("span", null, icon(item.icon || 'fas fa-bullhorn')), m("div", null, m("strong", null, item.title), m("p", null, item.message)), item.link_url ? m(Link, {
      href: item.link_url,
      onclick: () => this.track(item.link_url)
    }, item.link_label || 'SPRAWDŹ') : null, item.dismissible ? m("button", {
      type: "button",
      "aria-label": "Zamknij og\u0142oszenie",
      onclick: () => this.dismiss(item.id)
    }, icon('fas fa-times')) : null)));
  }
}
flarum.reg.add('novatruck-theme', 'forum/components/HomeAnnouncements', HomeAnnouncements);